<div class="layout-wrapper">
    <a href="#main-content" class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-lg focus:bg-surface-0 focus:shadow-lg">Skip to content</a>
    <div class="layout-main-container">
        <div class="layout-main">
            <div
                class="resize-container-1 flex relative lg:static bg-surface-50 dark:bg-surface-950">
                <app-sidebar></app-sidebar>

                <div class="flex flex-col relative flex-auto overflow-hidden">
                    <div class="main-content overflow-visible">
                        <div
                            #layoutTopbar
                            class="sticky top-0 z-20 bg-surface-0 dark:bg-surface-900 border-b border-surface-200 dark:border-surface-700">
                            @if (!isProduction()) {
                                <div
                                    class="bg-amber-400 text-amber-950 text-label font-semibold text-center py-1 tracking-widest uppercase select-none">
                                    {{ environmentName }} environment &mdash; not for production use
                                </div>
                            }
                            <div class="flex justify-between items-center py-4 px-4 lg:px-8">
                                <div class="flex items-center gap-3 min-w-0">
                                    <!--Mobile hamburger -->
                                    <div class="flex flex-col gap-4 overflow-hidden">
                                        <a
                                            pStyleClass="#app-sidebar-1"
                                            enterFromClass="hidden"
                                            enterActiveClass="animate-fadeinleft"
                                            leaveToClass="hidden"
                                            leaveActiveClass="animate-fadeoutleft"
                                            [hideOnOutsideClick]="true"
                                            resizeSelector=".resize-container-1"
                                            [hideOnResize]="true"
                                            class="cursor-pointer block lg:hidden text-surface-700 dark:text-surface-100">
                                            <i class="pi pi-bars text-2xl"></i>
                                        </a>
                                    </div>
                                    <!--Desktop hamburger -->
                                    <div class="flex flex-col gap-4 overflow-hidden">
                                        <button
                                            type="button"
                                            aria-label="Toggle sidebar"
                                            class="hidden lg:inline-flex items-center bg-transparent border-0 p-2 -m-2 cursor-pointer"
                                            (click)="toggleSidebar()">
                                            <i class="pi pi-bars text-2xl"></i>
                                        </button>
                                    </div>

                                    <div class="flex flex-col gap-4 overflow-hidden min-w-0">
                                        <p-breadcrumb
                                            [home]="home"
                                            [model]="items"
                                            class="truncate"></p-breadcrumb>
                                    </div>
                                </div>

                                <div class="flex items-center gap-4 relative shrink-0" #profileContainer>
                                    <button
                                        type="button"
                                        class="hidden sm:block max-w-[16rem] truncate bg-transparent border-0 p-0 cursor-pointer font-inherit text-inherit"
                                        [title]="displayName"
                                        [attr.aria-expanded]="profileMenuVisible"
                                        aria-controls="profile-menu"
                                        (click)="toggleProfileMenu()">
                                        {{ displayName }}
                                    </button>
                                    <button
                                        type="button"
                                        class="p-1.5 -m-1.5 rounded-full bg-transparent border-none cursor-pointer flex items-center"
                                        aria-label="Open profile menu"
                                        [attr.aria-expanded]="profileMenuVisible"
                                        aria-controls="profile-menu"
                                        (click)="toggleProfileMenu()">
                                        <app-avatar [name]="displayName" size="sm" />
                                    </button>

                                    @if (profileMenuVisible) {
                                        <div
                                            id="profile-menu"
                                            class="absolute top-full right-0 mt-2 w-52 rounded-2xl border border-surface overflow-hidden bg-surface-0 dark:bg-surface-900 shadow-lg z-50"
                                            (click)="$event.stopPropagation()">
                                            <ul class="flex flex-col gap-1 p-2 m-0">
                                                <li>
                                                    <a
                                                        routerLink="/account/profile"
                                                        (click)="profileMenuVisible = false"
                                                        class="text-sm dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                                                        <i class="pi pi-user"></i>
                                                        <span>Profile</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        class="text-sm dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer w-full text-left bg-transparent border-0"
                                                        (click)="profileMenuVisible = false; logout()">
                                                        <i class="pi pi-power-off"></i>
                                                        <span>Log out</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div id="main-content" tabindex="-1" class="outline-none focus:outline-none p-4 md:p-6 lg:p-8 flex flex-col flex-auto">
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                    <footer
                        class="flex-shrink-0 px-4 lg:px-8 py-3 flex items-center justify-between gap-2 border-t border-surface-200 dark:border-surface-700">
                        <span class="help-text">
                            Powered by
                            <span class="font-semibold text-surface-500">RICLAB</span>
                            &bull; &copy; {{ currentYear }}
                        </span>
                        <app-debug-panel />
                    </footer>
                </div>
            </div>
        </div>
        <div class="layout-mask animate-fadein"></div>
        <p-scrolltop [buttonProps]="{ severity: 'primary', raised: true, rounded: true }" />
    </div>
</div>
